<script lang="ts">
  export let src: string;
  export let alt: string;
  export let bgColor: string = "#f5f5f5";
  export let animatedText: string = "";
</script>

<div class="portrait-image-wrapper" style="background: {bgColor};">
  <img src={src} alt={alt} class="portrait-img" />
  <div class="animated-text">
    {#if animatedText}
      <span>{animatedText}</span>
    {/if}
  </div>
</div>

<style>
  .portrait-image-wrapper {
    position: relative;
    width: 100%;
    max-width: 900px;
    min-height: 500px;
    margin: 2rem auto;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 4rem;
    border-radius: 2rem;
    box-shadow: 0 2px 16px rgba(0,0,0,0.08);
  }
  .portrait-img {
    max-height: 70vh;
    max-width: 100%;
    object-fit: contain;
    z-index: 1;
    display: block;
    margin: 0 auto;
  }
  .animated-text {
    position: absolute;
    bottom: .5rem;
    left: 0;
    width: 100%;
    text-align: center;
    color: #212121;
    font-size: 1rem;
    opacity: 0;
    animation: fadeInDown 1s 0.2s forwards;
    pointer-events: none;
    padding: 0.5rem 1rem;
  }
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .caption {
    width: 100%;
    text-align: center;
    font-size: 1rem;
    font-weight: 500;
    color: #222;
    margin-top: 2rem;
    opacity: 0;
    animation: fadeInUp 1s 0.2s forwards;
  }
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style> 